export default "__VITE_ASSET__BLgALNT2__"